/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import {channelDefState} from './ChannelDefType';

export const supportedHandlers = {
    "json-table": {
        name: "Configurable table list"
    },
    "json-detail": {
        name: "Detail"
    },
    "html-template": {
        name: "HTML Template"
    },
};

export const supportedBackendHandlers = {
    "": {
        name: "(none)"
    },
    "merk": {
        name: "Merk"
    },
    "links": {
        name: "Links"
    },
};



export default declareEntity({
    entity: "entityViewDefs",
    graphQL: "EntityViewDef",
    name: "Entity View Definitions",
    dynamoPrefix: 'def',
    storageType: 'schema',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "entityViewDefs",
    defaultOrder: ['entityDef_id', 'name'],
    defaultTitle: (data) => {
        return data['name'];
    },
    onModify: ['groupDef'],
    isPublic: true,
    fields: (types) => { return {
        id: {
            name: "Entity View Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            isPublic: true,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            required: true,
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        handler: {
            name: "Handler",
            type: "enum",
            defaultValue: "json-table",
            values: supportedHandlers,
            isPublic: true,
        },
        backendHandlers: {
            name: "Backend Handler",
            type: "object",
            defaultValue: [],
        },
        backendOptions: {
            name: "Backend Options",
            type: "object",
            defaultValue: {},
        },
        forList: {
            name: "Is it list",
            type: "boolean",
            defaultValue: true,
            isPublic: true,
        },
        hideInDefaultQuery: {
            name: "Hide in default query",
            description: "When looking on entry as default query, hide this view.",
            type: "boolean",
            defaultValue: true,
            isPublic: true,
        },
        dependsOnChannelDef: {
            name: "Depends on Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            filterable: true,
            isPublic: true,
        },
        dependentChannelRequirement: {
            name: "Requirement of Application for usage",
            type: "enum",
            defaultValue: "requires-channel",
            values: {
                "requires-channel": {
                    name: "Only with Application",
                },
                "without-channel": {
                    name: "Can be used without Application",
                },
            },
            visibility: (data) => { return data['dependsOnChannelDef'] || data['dependsOnChannelDef_id'] ? true : false; }
        },
        defaultUsage: {
            name: "Default Usage",
            type: "enum",
            defaultValue: "none",
            description: "In some parts of application, we need to show default list or view (eg. in channel detail)",
            values: {
                "none": {
                    name: "None",
                },
                "default-list": {
                    name: "Default List",
                },
                "default-detail": {
                    name: "Default Detail",
                }
            }
        },
        title: {
            name: "Title",
            type: "string",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        template: {
            name: "Template",
            type: "text",
            defaultValue: "",
			description: "There are some semantic class names: 'header' for header, 'data' to wrap all data elements, 'optional' for elements which may not be filled",
            isPublic: true,
        },
		filter: {
            name: "Filter",
            type: "object",
            defaultValue: {},
			description: "Filter object for data query",
            isPublic: true,
		},
        state: {
            name: "State",
            type: "enum",
            filterable: true,
            isPublic: true,
            defaultValue: "draft",
            values: channelDefState
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            filterable: true,
            isPublic: true,
            defaultValue: "private",
            values: {
                "private": {
                    name: "Private",
                },
                "unlisted": {
                    name: "Unlisted",
                },
                "public": {
                    name: "Public",
                },
            }
        },
		order: {
            name: "Order",
            type: "object",
            defaultValue: [],
			description: "Order of the data in the query",
            isPublic: true,
		},
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
